export default [
    {
        lat: 49.31,
        lng: 11.17,
    },
    {
        lat: 49.325,
        lng: 11.18,
    },
    {
        lat: 49.335,
        lng: 11.225,
    },
    {
        lat: 49.345,
        lng: 11.235,
    },
    {
        lat: 49.345,
        lng: 11.275,
    },
    {
        lat: 49.335,
        lng: 11.285,
    },
    {
        lat: 49.325,
        lng: 11.325,
    },
    {
        lat: 49.34,
        lng: 11.335,
    },
    {
        lat: 49.345,
        lng: 11.355,
    },
    {
        lat: 49.365,
        lng: 11.35,
    },
    {
        lat: 49.375,
        lng: 11.36,
    },
    {
        lat: 49.395,
        lng: 11.405,
    },
    {
        lat: 49.41,
        lng: 11.41,
    },
    {
        lat: 49.415,
        lng: 11.425,
    },
    {
        lat: 49.44,
        lng: 11.43,
    },
    {
        lat: 49.455,
        lng: 11.46,
    },
    {
        lat: 49.43,
        lng: 11.535,
    },
    {
        lat: 49.46,
        lng: 11.55,
    },
    {
        lat: 49.47,
        lng: 11.565,
    },
    {
        lat: 49.485,
        lng: 11.55,
    },
    {
        lat: 49.49,
        lng: 11.52,
    },
    {
        lat: 49.51,
        lng: 11.51,
    },
    {
        lat: 49.525,
        lng: 11.52,
    },
    {
        lat: 49.545,
        lng: 11.49,
    },
    {
        lat: 49.575,
        lng: 11.5,
    },
    {
        lat: 49.585,
        lng: 11.535,
    },
    {
        lat: 49.615,
        lng: 11.53,
    },
    {
        lat: 49.63,
        lng: 11.555,
    },
    {
        lat: 49.645,
        lng: 11.545,
    },
    {
        lat: 49.67,
        lng: 11.545,
    },
    {
        lat: 49.685,
        lng: 11.525,
    },
    {
        lat: 49.705,
        lng: 11.525,
    },
    {
        lat: 49.715,
        lng: 11.54,
    },
    {
        lat: 49.735,
        lng: 11.53,
    },
    {
        lat: 49.755,
        lng: 11.545,
    },
    {
        lat: 49.75,
        lng: 11.575,
    },
    {
        lat: 49.77,
        lng: 11.58,
    },
    {
        lat: 49.775,
        lng: 11.605,
    },
    {
        lat: 49.815,
        lng: 11.615,
    },
    {
        lat: 49.83,
        lng: 11.64,
    },
    {
        lat: 49.83,
        lng: 11.685,
    },
    {
        lat: 49.86,
        lng: 11.73,
    },
    {
        lat: 49.86,
        lng: 11.785,
    },
    {
        lat: 49.87,
        lng: 11.8,
    },
    {
        lat: 49.865,
        lng: 11.82,
    },
    {
        lat: 49.88,
        lng: 11.82,
    },
    {
        lat: 49.89,
        lng: 11.805,
    },
    {
        lat: 49.915,
        lng: 11.805,
    },
    {
        lat: 49.92,
        lng: 11.795,
    },
    {
        lat: 49.945,
        lng: 11.785,
    },
    {
        lat: 49.96,
        lng: 11.785,
    },
    {
        lat: 49.98,
        lng: 11.8,
    },
    {
        lat: 49.98,
        lng: 11.86,
    },
    {
        lat: 50,
        lng: 11.9,
    },
    {
        lat: 49.99,
        lng: 11.92,
    },
    {
        lat: 49.995,
        lng: 11.955,
    },
    {
        lat: 50.005,
        lng: 11.97,
    },
    {
        lat: 50,
        lng: 12,
    },
    {
        lat: 50.01,
        lng: 12.005,
    },
    {
        lat: 50.005,
        lng: 12.055,
    },
    {
        lat: 50.015,
        lng: 12.06,
    },
    {
        lat: 50.015,
        lng: 12.085,
    },
    {
        lat: 50,
        lng: 12.105,
    },
    {
        lat: 50.015,
        lng: 12.14,
    },
    {
        lat: 50.015,
        lng: 12.17,
    },
    {
        lat: 50.05,
        lng: 12.185,
    },
    {
        lat: 50.055,
        lng: 12.235,
    },
    {
        lat: 50.08,
        lng: 12.255,
    },
    {
        lat: 50.08,
        lng: 12.305,
    },
    {
        lat: 50.075,
        lng: 12.325,
    },
    {
        lat: 50.06,
        lng: 12.335,
    },
    {
        lat: 50.06,
        lng: 12.35,
    },
    {
        lat: 50.035,
        lng: 12.385,
    },
    {
        lat: 50.035,
        lng: 12.41,
    },
    {
        lat: 50.02,
        lng: 12.425,
    },
    {
        lat: 50.015,
        lng: 12.47,
    },
    {
        lat: 50,
        lng: 12.485,
    },
    {
        lat: 50,
        lng: 12.5,
    },
    {
        lat: 49.98,
        lng: 12.52,
    },
    {
        lat: 49.95,
        lng: 12.51,
    },
    {
        lat: 49.945,
        lng: 12.55,
    },
    {
        lat: 49.935,
        lng: 12.565,
    },
    {
        lat: 49.895,
        lng: 12.57,
    },
    {
        lat: 49.875,
        lng: 12.555,
    },
    {
        lat: 49.87,
        lng: 12.54,
    },
    {
        lat: 49.82,
        lng: 12.51,
    },
    {
        lat: 49.82,
        lng: 12.495,
    },
    {
        lat: 49.805,
        lng: 12.49,
    },
    {
        lat: 49.78,
        lng: 12.495,
    },
    {
        lat: 49.765,
        lng: 12.48,
    },
    {
        lat: 49.755,
        lng: 12.435,
    },
    {
        lat: 49.745,
        lng: 12.435,
    },
    {
        lat: 49.72,
        lng: 12.455,
    },
    {
        lat: 49.715,
        lng: 12.49,
    },
    {
        lat: 49.705,
        lng: 12.5,
    },
    {
        lat: 49.71,
        lng: 12.515,
    },
    {
        lat: 49.705,
        lng: 12.535,
    },
    {
        lat: 49.675,
        lng: 12.55,
    },
    {
        lat: 49.645,
        lng: 12.545,
    },
    {
        lat: 49.64,
        lng: 12.57,
    },
    {
        lat: 49.63,
        lng: 12.58,
    },
    {
        lat: 49.56,
        lng: 12.6,
    },
    {
        lat: 49.55,
        lng: 12.61,
    },
    {
        lat: 49.55,
        lng: 12.65,
    },
    {
        lat: 49.53,
        lng: 12.665,
    },
    {
        lat: 49.5,
        lng: 12.66,
    },
    {
        lat: 49.445,
        lng: 12.68,
    },
    {
        lat: 49.445,
        lng: 12.715,
    },
    {
        lat: 49.43,
        lng: 12.73,
    },
    {
        lat: 49.42,
        lng: 12.76,
    },
    {
        lat: 49.4,
        lng: 12.78,
    },
    {
        lat: 49.385,
        lng: 12.78,
    },
    {
        lat: 49.37,
        lng: 12.8,
    },
    {
        lat: 49.36,
        lng: 12.8,
    },
    {
        lat: 49.365,
        lng: 12.835,
    },
    {
        lat: 49.36,
        lng: 12.865,
    },
    {
        lat: 49.37,
        lng: 12.875,
    },
    {
        lat: 49.365,
        lng: 12.95,
    },
    {
        lat: 49.355,
        lng: 12.98,
    },
    {
        lat: 49.325,
        lng: 13.02,
    },
    {
        lat: 49.325,
        lng: 13.035,
    },
    {
        lat: 49.31,
        lng: 13.05,
    },
    {
        lat: 49.285,
        lng: 13.05,
    },
    {
        lat: 49.28,
        lng: 13.07,
    },
    {
        lat: 49.265,
        lng: 13.075,
    },
    {
        lat: 49.265,
        lng: 13.095,
    },
    {
        lat: 49.24,
        lng: 13.11,
    },
    {
        lat: 49.24,
        lng: 13.12,
    },
    {
        lat: 49.225,
        lng: 13.135,
    },
    {
        lat: 49.21,
        lng: 13.14,
    },
    {
        lat: 49.19,
        lng: 13.185,
    },
    {
        lat: 49.16,
        lng: 13.19,
    },
    {
        lat: 49.125,
        lng: 13.175,
    },
    {
        lat: 49.12,
        lng: 13.155,
    },
    {
        lat: 49.09,
        lng: 13.14,
    },
    {
        lat: 49.09,
        lng: 13.115,
    },
    {
        lat: 49.105,
        lng: 13.07,
    },
    {
        lat: 49.12,
        lng: 13.05,
    },
    {
        lat: 49.135,
        lng: 13.045,
    },
    {
        lat: 49.14,
        lng: 13.03,
    },
    {
        lat: 49.135,
        lng: 13.02,
    },
    {
        lat: 49.14,
        lng: 12.975,
    },
    {
        lat: 49.12,
        lng: 12.955,
    },
    {
        lat: 49.11,
        lng: 12.925,
    },
    {
        lat: 49.115,
        lng: 12.875,
    },
    {
        lat: 49.1,
        lng: 12.8,
    },
    {
        lat: 49.105,
        lng: 12.785,
    },
    {
        lat: 49.09,
        lng: 12.775,
    },
    {
        lat: 49.095,
        lng: 12.725,
    },
    {
        lat: 49.08,
        lng: 12.695,
    },
    {
        lat: 49.085,
        lng: 12.66,
    },
    {
        lat: 49.07,
        lng: 12.56,
    },
    {
        lat: 49.04,
        lng: 12.54,
    },
    {
        lat: 49.04,
        lng: 12.505,
    },
    {
        lat: 48.975,
        lng: 12.51,
    },
    {
        lat: 48.955,
        lng: 12.495,
    },
    {
        lat: 48.955,
        lng: 12.475,
    },
    {
        lat: 48.94,
        lng: 12.465,
    },
    {
        lat: 48.93,
        lng: 12.475,
    },
    {
        lat: 48.91,
        lng: 12.475,
    },
    {
        lat: 48.9,
        lng: 12.47,
    },
    {
        lat: 48.895,
        lng: 12.455,
    },
    {
        lat: 48.86,
        lng: 12.445,
    },
    {
        lat: 48.855,
        lng: 12.42,
    },
    {
        lat: 48.83,
        lng: 12.395,
    },
    {
        lat: 48.825,
        lng: 12.375,
    },
    {
        lat: 48.84,
        lng: 12.32,
    },
    {
        lat: 48.82,
        lng: 12.305,
    },
    {
        lat: 48.825,
        lng: 12.285,
    },
    {
        lat: 48.815,
        lng: 12.255,
    },
    {
        lat: 48.79,
        lng: 12.245,
    },
    {
        lat: 48.79,
        lng: 12.22,
    },
    {
        lat: 48.775,
        lng: 12.205,
    },
    {
        lat: 48.77,
        lng: 12.165,
    },
    {
        lat: 48.745,
        lng: 12.14,
    },
    {
        lat: 48.745,
        lng: 12.1,
    },
    {
        lat: 48.77,
        lng: 12.075,
    },
    {
        lat: 48.795,
        lng: 12.075,
    },
    {
        lat: 48.805,
        lng: 12.085,
    },
    {
        lat: 48.855,
        lng: 12.08,
    },
    {
        lat: 48.885,
        lng: 12.095,
    },
    {
        lat: 48.885,
        lng: 12.07,
    },
    {
        lat: 48.895,
        lng: 12.06,
    },
    {
        lat: 48.925,
        lng: 12.055,
    },
    {
        lat: 48.935,
        lng: 12.02,
    },
    {
        lat: 48.93,
        lng: 11.98,
    },
    {
        lat: 48.94,
        lng: 11.975,
    },
    {
        lat: 48.925,
        lng: 11.95,
    },
    {
        lat: 48.925,
        lng: 11.92,
    },
    {
        lat: 48.94,
        lng: 11.9,
    },
    {
        lat: 48.975,
        lng: 11.885,
    },
    {
        lat: 49,
        lng: 11.85,
    },
    {
        lat: 48.995,
        lng: 11.81,
    },
    {
        lat: 48.985,
        lng: 11.81,
    },
    {
        lat: 48.96,
        lng: 11.78,
    },
    {
        lat: 48.975,
        lng: 11.72,
    },
    {
        lat: 48.995,
        lng: 11.705,
    },
    {
        lat: 48.995,
        lng: 11.665,
    },
    {
        lat: 48.985,
        lng: 11.655,
    },
    {
        lat: 48.985,
        lng: 11.64,
    },
    {
        lat: 48.97,
        lng: 11.64,
    },
    {
        lat: 48.965,
        lng: 11.625,
    },
    {
        lat: 48.945,
        lng: 11.62,
    },
    {
        lat: 48.93,
        lng: 11.605,
    },
    {
        lat: 48.93,
        lng: 11.595,
    },
    {
        lat: 48.955,
        lng: 11.565,
    },
    {
        lat: 48.97,
        lng: 11.56,
    },
    {
        lat: 48.975,
        lng: 11.54,
    },
    {
        lat: 49,
        lng: 11.515,
    },
    {
        lat: 49.01,
        lng: 11.515,
    },
    {
        lat: 49.03,
        lng: 11.495,
    },
    {
        lat: 49.045,
        lng: 11.495,
    },
    {
        lat: 49.04,
        lng: 11.465,
    },
    {
        lat: 49.045,
        lng: 11.425,
    },
    {
        lat: 49.06,
        lng: 11.4,
    },
    {
        lat: 49.055,
        lng: 11.38,
    },
    {
        lat: 49.07,
        lng: 11.365,
    },
    {
        lat: 49.075,
        lng: 11.335,
    },
    {
        lat: 49.09,
        lng: 11.33,
    },
    {
        lat: 49.095,
        lng: 11.335,
    },
    {
        lat: 49.1,
        lng: 11.31,
    },
    {
        lat: 49.16,
        lng: 11.29,
    },
    {
        lat: 49.17,
        lng: 11.26,
    },
    {
        lat: 49.195,
        lng: 11.24,
    },
    {
        lat: 49.215,
        lng: 11.24,
    },
    {
        lat: 49.23,
        lng: 11.255,
    },
    {
        lat: 49.235,
        lng: 11.275,
    },
    {
        lat: 49.255,
        lng: 11.235,
    },
    {
        lat: 49.26,
        lng: 11.19,
    },
    {
        lat: 49.295,
        lng: 11.165,
    },
    {
        lat: 49.31,
        lng: 11.17,
    },
];
